import { Component, Input } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'confirm',
    template: require('./confirm.component.html'),
    styles: [require('./confirm.component.css')]
})

export class ConfirmComponent  {
    @Input() dialog: DialogRef;
    @Input() message: string;

    btnClicked(event) {
        if (event == 'yes')
            this.closeWindow(true);
        else
            this.closeWindow(false);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/confirm.component.ts